import React, { useState, useEffect } from 'react'
import i18next from 'i18next'
import '../../i18n/config'
import { useTranslation, initReactI18next } from 'react-i18next'
import {
  apiURL,
  canCreateUploadList,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import ModalMediaDatabase from 'gatsby-theme-kn/src/components/modules/ModalMediaDatabase'
import MediaDatabaseDownloadList from 'gatsby-theme-kn/src/components/technical/MediaDatabaseDownloadList'
import MediaDatabaseDownloadListShow from 'gatsby-theme-kn/src/components/technical/MediaDatabaseDownloadListShow'
import MediaDatabasePromotialOrder from 'gatsby-theme-kn/src/components/technical/MediaDatabasePromotialOrder'
import { Link } from 'gatsby'
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom'
import {
  downloadList,
  clickUploadToDownloadList,
  isUploadInList,
} from 'gatsby-theme-kn/src/utils/media_database_download_list'
import {
  shoppingCartList,
  addUploadToShoppingCart,
} from 'gatsby-theme-kn/src/utils/media_database_shopping_cart'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'

import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const MediaDatabase = (props) => {
  const params = props.params
  // Schalter für die Werbemittelbestellung
  const isPromotialOrder = props.isPromotialOrder || false

  if (typeof window !== 'undefined') {
    return (
      <BrowserRouter>
        <MediaDatabaseContent
          params={params}
          isPromotialOrder={isPromotialOrder}
        />
      </BrowserRouter>
    )
  }
  return null
}

const UploadList = ({
  uploads,
  isPromotialOrder,
  DownloadListMode,
  uploadClick,
  setDownloadListState,
  setShoppingCartState,
}) => {
  const { t } = useTranslation()

  const maximumPerOrder = (element, max) => {
    if (element.target.value > max) {
      element.target.value = max
    }
  }

  const orderable = (upload) => {
    if (upload.stock.maximum_per_order > 0) {
      return true
    } else {
      return false
    }
  }

  return (
    <div className="download-cards">
      <div className="download-card-deck">
        {uploads.map((upload, index) => (
          <div
            key={index}
            className={`download-card ${
              isUploadInList(upload.id) && DownloadListMode ? 'selected' : ''
            }`}
          >
            <a
              style={{ display: 'block', minHeight: '191px' }}
              href="/"
              onClick={(e) => {
                e.preventDefault()
                uploadClick(
                  upload.id,
                  DownloadListMode ? setDownloadListState : setShoppingCartState
                )
              }}
            >
              {upload.new_in_quarter && (
                <span className="card-label">
                  {t('generic.spa.media.index.new_file_badge_text')}
                </span>
              )}
              {upload.url && (
                <>
                  <Image
                    image={upload.url}
                    className="card-img"
                    title={upload.filename}
                    alt={upload.filename}
                    imageWidth="210"
                    imageHeight="210"
                    fillColor="f6f6f6"
                  />
                </>
              )}
            </a>
            <span className="download-title">
              {upload.title && upload.title}
              {!upload.title && upload.filename}
            </span>

            {isPromotialOrder && orderable(upload) && (
              <div
                className="download-cart-actions"
                title={t('generic.spa.media.add_to_cart')}
              >
                <input
                  type="number"
                  min="1"
                  max={upload.stock.maximum_per_order}
                  step="1"
                  defaultValue="1"
                  id={`amount-${upload.id}`}
                  data-type={upload.type}
                  className="promotial-order-amount"
                  onChange={(e) => {
                    e.preventDefault()
                    maximumPerOrder(e, upload.stock.maximum_per_order)
                  }}
                />
                /{upload.stock.maximum_per_order}
                &nbsp;
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault()
                    addUploadToShoppingCart(upload.id, setShoppingCartState)
                  }}
                >
                  <i className="fa fa-cart-arrow-down"></i>
                </a>
              </div>
            )}

            {isPromotialOrder && !orderable(upload) && (
              <div
                className="download-cart-actions"
                title={t('generic.spa.media.add_to_cart')}
              >
                <span className="download-title">
                  {t('generic.spa.media.index.not_available')}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

const MediaDatabaseContent = (props) => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const params = props.params
  const isPromotialOrder = props.isPromotialOrder
  const [uploadPath, setUploadPath] = useState(null)
  const [modalState, setModalState] = useState(false)
  const [RouterParams, setRouterParams] = useState(null)
  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    {},
    'get'
  )

  const locale = i18next.use(initReactI18next).language

  if (typeof window !== 'undefined') {
    useEffect(() => {
      location.hash === '' && navigate(`#!overview`)
    }, [location.hash])
  }

  useEffect(() => {
    const params = RouterParams || {}
    // Als Antwort wird nur eine UploadCategory geliefert
    // => direkt in die UploadCategory springen
    if (
      !params['upload_category'] &&
      data?.content.categories &&
      data?.content.categories.length === 1
    ) {
      addRoutingAttribute('upload_category', data?.content.categories[0]['id'])
      return
    }

    if (
      !params['category'] &&
      data?.content.categories &&
      data?.content.categories.length === 1
    ) {
      addRoutingAttribute('category', data?.content.categories[0]['id'])
      return
    }
  }, [data])

  // Klick in der MDB der ein Auswahl-Kriterium hinzufügt
  const addRoutingAttribute = (attr_name, attr_value) => {
    let rp = RouterParams
    rp[attr_name] = attr_value
    setRouterParams(rp)
    setPartnerPortalUrl(buildPartnerPortalPathFromParams())
    navigate({ hash: buildHashFromParams() })
  }
  // Klick in der MDB der ein Auswahl-Kriterium entfernt
  const removeRoutingAttribute = function (attr_name) {
    let rp = RouterParams
    rp[attr_name] = null
    setRouterParams(rp)
    setPartnerPortalUrl(buildPartnerPortalPathFromParams())
    navigate({ hash: buildHashFromParams() })
  }
  const clearRoutingAttributes = function () {
    setRouterParams({})
    navigate({ hash: '#' })
  }

  // Nötig für clearRoutingAttributes um rerender zu triggern
  useEffect(() => {
    if (RouterParams) {
      setPartnerPortalUrl(buildPartnerPortalPathFromParams())
    }
  }, [RouterParams])

  // Root-Aufruf oder DeepLink
  useEffect(() => {
    setRouterParamsFromLocationHash()
  }, [])

  // Anhand der RouterParams (die per Klick hinzugefügt oder entfernt werden)
  // => Es wird die Partner-Portal API URL zusammengebaut
  const buildPartnerPortalPathFromParams = () => {
    const params = RouterParams || {}
    let path = ''
    // Werbemittel-Bestellung (isPromotialOrder) hat eigene Route
    if (isPromotialOrder) {
      path = 'media_engine/promotional_orders?v=1&locale=' + locale
    } else {
      path = 'media_engine/uploads?v=1&locale=' + locale
    }

    if (params['query']) {
      path += '&q=' + params['query']
    }
    if (params['category']) {
      path += '&item_id=' + params['category']
    }
    if (params['upload_category']) {
      path += '&category_id=' + params['upload_category']
    }
    if (params['default_filter']) {
      path += '&default_filter=' + params['default_filter']
    }

    return apiURL(path)
  }

  // Anhand der RouterParams (die per Klick hinzugefügt oder entfernt werden)
  // => Es wird der LocationHash (für die URL) zusammengebaut
  const buildHashFromParams = () => {
    const params = RouterParams || {}
    let path = '#!'
    if (Object.keys(params).length === 0) {
      path += 'overview'
    }
    if (params['category']) {
      path += 'category/' + params['category'] + '/'
    }
    if (params['upload_category']) {
      path += 'upload_category/' + params['upload_category'] + '/'
    }
    if (params['q']) {
      path += 'query/' + params['query'] + '/'
    }
    if (params['default_filter']) {
      path += 'default_filter/' + params['default_filter'] + '/'
    }
    if (params['download_list']) {
      path += 'download_list/' + params['download_list'] + '/'
    }
    return path
  }

  // Beim Aufruf eines DeepLinks (zB: /de/medien/#!category/mGNP8GNV)
  // werden die Hash-Komponenten in RouterParams umgewandelt
  const setRouterParamsFromLocationHash = () => {
    if (typeof window !== 'undefined') {
      let params = {}
      let last_route = (window.location.hash || '').split('#!')[1]
      if (last_route) {
        let split_route = last_route.split('/') || []
        const types = [
          'upload_category',
          'category',
          'tags',
          'query',
          'default_filter',
          'download_list',
        ]
        types.map((t) => {
          let param_index = split_route.indexOf(t)
          if (param_index >= 0) {
            params[t] = split_route[param_index + 1]
          }
        })
      }
      setRouterParams(params)
    }
  }

  // Modal: Upload-Detail
  const triggerModal = (uploadId) => {
    setUploadPath('media_engine/uploads/' + uploadId)
    setModalState(true)
    navigate({ hash: 'upload/' + uploadId })
  }
  const closeModal = () => {
    setModalState(false)
    navigate({ hash: buildHashFromParams() })
  }

  const [modalTitle, setModalTitle] = useState(null)
  const [modalIconTitle, setModalIconTitle] = useState(null)

  // Download-Listen Modus
  const [DownloadListMode, setDownloadListMode] = useState(false)
  // Download-Listen Daten
  const [downloadListState, setDownloadListState] = useState(downloadList())

  // Shopping-Cart Daten (Werbemittelbestellung)
  const [shoppingCartState, setShoppingCartState] = useState(shoppingCartList())

  // Im Download-Listen Modus wird der Upload in die Zwischenablage (unten) gelegt
  // Im Werbemittel-Modus wird der Upload in die Zwischenablage (unten) gelegt
  // Ansonsten wird der Upload im Modal angezeigt
  const uploadClick = (uploadId, setter) => {
    if (DownloadListMode) {
      clickUploadToDownloadList(uploadId, setter)
    } else if (isPromotialOrder) {
      addUploadToShoppingCart(uploadId, setter)
    } else {
      triggerModal(uploadId)
    }
  }

  // wann wird die Liste neu gerendert? dann rellax neu initialisieren
  useEffect(() => {
    if (window && window.initRellaxScrolls) {
      window.initRellaxScrolls()
    }
  }, [data, data?.content])

  return (
    <>
      <ModalModule
        isOpen={modalState}
        closeModal={closeModal}
        title={modalTitle}
        icon={modalIconTitle}
      >
        <ModalMediaDatabase
          uploadPath={uploadPath}
          titleSetter={setModalTitle}
          iconSetter={setModalIconTitle}
          closeModal={closeModal}
          addRoutingAttribute={addRoutingAttribute}
        />
      </ModalModule>

      <div className="spa-block-row">
        <div className="spa-block-header">
          <div className="spa-block-header-wrapper">
            <div>
              {Object.keys(RouterParams || {}).length > 0 && (
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault()
                    clearRoutingAttributes()
                  }}
                >
                  <i className="fal fa-chevron-left"></i>
                  &nbsp;
                  {t('generic.spa.media.index.all')}
                </a>
              )}
            </div>

            {isPromotialOrder && (
              <p data-behavior="localeSwitcher">
                <a
                  className="nav-item"
                  href={t('generic.spa.paths.promotional_orders_de')}
                >
                  DE
                </a>
                <span className="muted">|</span>
                <a
                  className="nav-item"
                  href={t('generic.spa.paths.promotional_orders_en')}
                >
                  EN
                </a>
                <span className="muted">|</span>
                <a
                  className="nav-item"
                  href={t('generic.spa.paths.promotional_orders_fr')}
                >
                  FR
                </a>
                <span className="muted">|</span>
                <a
                  className="nav-item"
                  href={t('generic.spa.paths.promotional_orders_nl')}
                >
                  NL
                </a>
              </p>
            )}

            <form className="needs-validation spa-block-header-form">
              {canCreateUploadList() && !isPromotialOrder && (
                <div className="media-db-download-list-toggle custom-control custom-checkbox form-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input form-check-input"
                    id="customCheck1"
                    onChange={(e) => {
                      setDownloadListMode(e.target.checked)
                    }}
                  />
                  &nbsp;
                  <label
                    className="custom-control-label form-check-label"
                    htmlFor="customCheck1"
                  >
                    {t('generic.spa.media.index.download_list_mode')}
                  </label>
                </div>
              )}
              <div className="input-group">
                <label className="sr-only" htmlFor="media-search">
                  {t('generic.spa.media.index.search_plh')}
                </label>
                <input
                  id="media-search"
                  placeholder={t('generic.spa.media.index.search_plh')}
                  type="search"
                  className="form-control"
                  name="s"
                  autoComplete="off"
                  onChange={(e) => {
                    e.preventDefault()
                    addRoutingAttribute('query', e.target.value)
                  }}
                />

                {data?.suggestions && (
                  <ul
                    id="media-search-suggestions"
                    className="list-unstyled"
                    style={{ display: 'block' }}
                  >
                    {/* Suchvorschläge: Produkte */}
                    {data?.suggestions.products &&
                      data?.suggestions.products.length > 0 && (
                        <>
                          <li className="headline">
                            {t('generic.spa.media.index.products')}
                          </li>
                          {data?.suggestions.products.map((p, index) => (
                            <li key={index}>
                              <a
                                href="/"
                                onClick={(e) => {
                                  e.preventDefault()
                                  addRoutingAttribute('category', p.id)
                                  removeRoutingAttribute('query')
                                }}
                              >
                                {p.title}
                              </a>
                            </li>
                          ))}
                        </>
                      )}

                    {/* Suchvorschläge: Kategorien */}
                    {data?.suggestions.categories &&
                      data?.suggestions.categories.length > 0 && (
                        <>
                          <li className="headline">
                            {t('generic.spa.media.index.categories')}
                          </li>
                          {data?.suggestions.categories.map((c, index) => (
                            <li key={index}>
                              <a
                                href="/"
                                onClick={(e) => {
                                  e.preventDefault()
                                  addRoutingAttribute('category', c.id)
                                  removeRoutingAttribute('query')
                                }}
                              >
                                {c.title}
                              </a>
                            </li>
                          ))}
                        </>
                      )}
                  </ul>
                )}
              </div>
            </form>
          </div>
        </div>

        <div className="spa-block-sidebar">
          <div className="facet-filter-panel">
            <h3>{t('generic.spa.media.index.product_planning_data_label')}</h3>
            <ul className="nav flex-column">
              <li>
                <a
                  href={t('generic.spa.media.index.product_planning_data_url')}
                  target="blank"
                >
                  pCon Catalog
                </a>
              </li>
            </ul>
            <br />
            {data?.navigation?.default_filters && (
              <>
                <h3>{t('generic.spa.media.index.default_filters')}</h3>
                <ul className="nav flex-column">
                  {data?.navigation?.default_filters.map(
                    (default_filter, index) => (
                      <li key={index} className="nav-item">
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault()
                            addRoutingAttribute(
                              'default_filter',
                              default_filter.id
                            )
                          }}
                        >
                          {default_filter.title}
                        </a>
                      </li>
                    )
                  )}
                </ul>
                <br />
              </>
            )}
            {data?.content?.category && (
              <h3>{data?.content?.category.title}</h3>
            )}
            {!data?.content?.category && (
              <h3>{t('generic.spa.media.index.categories')}</h3>
            )}

            {data?.content?.category?.parents && (
              <ul className="nav flex-column">
                {data?.content?.category.parents.map((category, index) => (
                  <li key={index} className="nav-item">
                    {/*
                    <pre>{JSON.stringify(category, null, 2)}</pre>
                    */}
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault()
                        addRoutingAttribute('category', category.id)
                      }}
                    >
                      <i className="fal fa-chevron-left"></i>
                      &nbsp;
                      {category.title}
                    </a>
                  </li>
                ))}
              </ul>
            )}

            {data?.navigation?.categories && (
              <ul className="nav flex-column">
                {data?.navigation?.categories.map((category, index) => (
                  <li key={index} className="nav-item">
                    {/*
                    <pre>{JSON.stringify(category, null, 2)}</pre>
                    */}
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault()
                        addRoutingAttribute('category', category.id)
                      }}
                    >
                      {category.title}
                      <span className="small float-end">
                        {category.upload_count}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            )}

            {data?.navigation?.upload_categories && (
              <ul className="nav flex-column">
                {data?.navigation?.upload_categories.map(
                  (upload_category, index) => (
                    <li key={index} className="nav-item">
                      {/*
                    <pre>{JSON.stringify(category, null, 2)}</pre>
                    */}
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault()
                          addRoutingAttribute(
                            'upload_category',
                            upload_category.id
                          )
                        }}
                      >
                        {upload_category.title}
                        <span className="small float-end">
                          {upload_category.upload_count}
                        </span>
                      </a>
                    </li>
                  )
                )}
              </ul>
            )}
          </div>
        </div>

        <div className="spa-block-main">
          <div id="media-index-content">
            <div className="downloads">
              {loading && <LoadingSpinner />}

              {data?.content.upload_category && (
                <>
                  <a
                    className="float-end"
                    href="/"
                    onClick={(e) => {
                      e.preventDefault()
                      removeRoutingAttribute('upload_category')
                    }}
                  >
                    <i className="fal fa-chevron-left"></i>
                    &nbsp;
                    {t('generic.spa.media.index.show_all_file_types')}
                  </a>
                  <h3>{data?.content.upload_category.title}</h3>
                </>
              )}

              {data?.content.uploads && data?.content.uploads.length > 0 && (
                <UploadList
                  uploads={data?.content.uploads}
                  isPromotialOrder={isPromotialOrder}
                  DownloadListMode={DownloadListMode}
                  uploadClick={uploadClick}
                  setDownloadListState={setDownloadListState}
                  setShoppingCartState={setShoppingCartState}
                />
              )}

              {data?.content?.categories?.map((category, index) => (
                <div key={index}>
                  {/*
                  <pre>{JSON.stringify(category.type, null, 2)}</pre>
                  */}
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault()
                      if (category.type === 'upload_category') {
                        addRoutingAttribute('upload_category', category.id)
                      }
                      if (category.type === 'category') {
                        addRoutingAttribute('category', category.id)
                      }
                    }}
                  >
                    {category.title}
                    &nbsp;
                    <span className="small">
                      {category.upload_count}
                      &nbsp;
                      <i className="fal fa-chevron-right"></i>
                    </span>
                  </a>

                  {category.uploads && (
                    <UploadList
                      uploads={category.uploads}
                      isPromotialOrder={isPromotialOrder}
                      DownloadListMode={DownloadListMode}
                      uploadClick={uploadClick}
                      setDownloadListState={setDownloadListState}
                      setShoppingCartState={setShoppingCartState}
                    />
                  )}
                </div>
              ))}
            </div>
            {/*
            <pre>{JSON.stringify(data?.content.categories[0], null, 2)}</pre>
            */}
          </div>
        </div>
      </div>

      {isPromotialOrder && (
        <MediaDatabasePromotialOrder setter={setShoppingCartState} />
      )}

      {!isPromotialOrder && (
        <MediaDatabaseDownloadList
          DownloadListMode={DownloadListMode}
          setter={setDownloadListState}
        />
      )}

      {RouterParams && RouterParams['download_list'] && (
        <MediaDatabaseDownloadListShow params={RouterParams} />
      )}
    </>
  )
}

export default MediaDatabase
